
import { Helmet } from 'react-helmet-async';
import GaleryListView from 'src/sections/galery/view/GaleryListView';

export default function GaleryListPage() {
  return (
    <>
      <Helmet>
        <title> Dashboard: Galeria</title>
      </Helmet>

      <GaleryListView />
    </>
  );
}
